/** Circular capacity gauge (iOS .accessoryCircularCapacity look): a ring filled
 * proportionally to value/100 with the number in the middle. */
export default function Gauge({
  value, size = 46, stroke = 5, color, textColor,
}: {
  value: number; size?: number; stroke?: number; color: string; textColor?: string;
}) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, value));
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden>
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(255,255,255,0.22)" strokeWidth={stroke} />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke={color}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray={`${(pct / 100) * c} ${c}`}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
      <text
        x="50%"
        y="54%"
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize={size * 0.34}
        fontWeight={800}
        fill={textColor ?? "#fff"}
      >
        {Math.round(pct)}
      </text>
    </svg>
  );
}
